export const setCampus = ( state, campus ) => {
    state.campus = campus
}